import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-returns',
  templateUrl: './modal-returns.component.html',
  styleUrls: ['./modal-returns.component.scss']
})
export class ModalReturnsComponent {
  @Output()
  modalReturnsInformationChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isModalReturnsShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalReturnsShow() {
    this.isModalReturnsShow = true;
    this.isDarkBackground = true;
  }

  openModalReturnsInformation() {
    this.modalReturnsInformationChange.emit();
  }

  closeModal() {
    this.isModalReturnsShow = false;
    this.isDarkBackground = false
  }
}
